import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { selectUser } from 'app/store/userSlice';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

function UserMenu(props) {
  const user = useSelector(selectUser);
  const { t } = useTranslation('translate-language');
  const [userMenu, setUserMenu] = useState(null);
  const [sep, setSep] = useState([]);
  const [data, setData] = useState([]);
  const userMenuClick = (event) => {
    setUserMenu(event.currentTarget);
  };

  useEffect(() => {
    axios.get(`/v1/user/get-by-id/${user.user_id}`).then(response => {
      setData(response?.data?.specializations);
    });
  }, [user]);

  useEffect(() => {
    axios.get(`v1/specialization/get-all`).then(response => {
      setSep(response.data);
    });
  }, []);

  const userMenuClose = () => {
    setUserMenu(null);
  };

  return (
    <>
      <Button
        className=" py-[28px] "
        onClick={userMenuClick}
        color="inherit"
      >
        {user?.photoURL ? (
          <Avatar className="md:mx-4" alt="user photo" src={user?.photoURL} />
        ) : (
          // <Avatar className="md:mx-4">{user?.full_name[0]}</Avatar>
          <></>
        )}
        <div className="hidden lg:flex flex-col mx-4 items-end">
          <Typography component="span" className="font-semibold flex text-[14px]">
            {user.full_name}
          </Typography>
          <Typography className="text-[11px] font-medium capitalize" color="text.secondary">
            {data?.map((row, i) => {
              const specialization = sep.find(s => s.id === row); // ID bo'yicha birinchi mos obyektni topish
              return (
                <span key={i}>
                  {specialization?.name}
                  {i < data.length - 1 && " | "} {/* Agar oxirgi element bo'lmasa, ' | ' qo'shilsin */}
                </span>
              );
            })}

          </Typography>
          <Typography className='text-[10px] font-medium capitalize' color="text.secondary">1$ ={user.currency_amount}</Typography>

        </div>


      </Button>

      <Popover
        open={Boolean(userMenu)}
        anchorEl={userMenu}
        onClose={userMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{
          paper: 'py-8',
        }}
      >
        {!user.role || user.role.length === 0 ? (
          <>
            <MenuItem component={Link} to="/sign-in" role="button">
              <ListItemIcon className="min-w-40">
                <FuseSvgIcon>heroicons-outline:lock-closed</FuseSvgIcon>
              </ListItemIcon>
              <ListItemText primary="Sign In" />
            </MenuItem>
            <MenuItem component={Link} to="/sign-up" role="button">
              <ListItemIcon className="min-w-40">
                <FuseSvgIcon>heroicons-outline:user-add </FuseSvgIcon>
              </ListItemIcon>
              <ListItemText primary="Sign up" />
            </MenuItem>
          </>
        ) : (
          <>
            <MenuItem component={Link} to="/profile" onClick={userMenuClose} role="button">
              <ListItemIcon className="min-w-40">
                <FuseSvgIcon>heroicons-outline:user-circle</FuseSvgIcon>
              </ListItemIcon>
              <ListItemText primary={t("MY_PROFILE")} />
            </MenuItem>

            <MenuItem
              component={NavLink}
              to="/sign-out"
              onClick={() => {
                userMenuClose();
              }}
            >
              <ListItemIcon className="min-w-40">
                <FuseSvgIcon color='error'>heroicons-outline:logout</FuseSvgIcon>
              </ListItemIcon>
              <ListItemText primary={t('SignOut')} />
            </MenuItem>
          </>
        )}
      </Popover>
    </>
  );
}

export default UserMenu;
